import { useState } from "react"
import { useAuth, useFirestore } from "reactfire"
import { createUserWithEmailAndPassword } from "firebase/auth"
import { doc, setDoc, serverTimestamp } from "firebase/firestore"
import { Link, useNavigate } from "react-router-dom"
import fondoFogata from "../assets/images/fogata2.jpg"
import logoGrupo from "../assets/images/logo-grupo.jpg"   // ← Asegúrate que el nombre coincida exactamente
import "../styles/auth.css"

export default function Register() {
  const auth = useAuth()
  const firestore = useFirestore()
  const navigate = useNavigate()

  const [form, setForm] = useState({
    email: "",
    password: "",
    confirmar: "",
  })
  const [cargando, setCargando] = useState(false)
  const [error, setError] = useState("")

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(f => ({ ...f, [name]: value }))
    setError("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!form.email || !form.password || !form.confirmar) {
      setError("Completa todos los campos.")
      return
    }
    if (form.password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.")
      return
    }
    if (form.password !== form.confirmar) {
      setError("Las contraseñas no coinciden.")
      return
    }

    setCargando(true)
    setError("")

    try {
      // 1. Crear usuario en Firebase Auth
      const { user } = await createUserWithEmailAndPassword(
        auth,
        form.email,
        form.password
      )

      // 2. Crear documento en Firestore con rol "viewer"
      await setDoc(doc(firestore, "users", user.uid), {
        email: user.email,
        rol: "viewer",
        creadoEn: serverTimestamp(),
      })

      navigate("/dashboard")
    } catch (err) {
      const mensajes = {
        "auth/email-already-in-use": "Ya existe una cuenta con ese correo.",
        "auth/invalid-email":        "El correo no es válido.",
        "auth/weak-password":        "La contraseña es muy débil.",
      }
      setError(mensajes[err.code] || "Error al crear la cuenta: " + err.message)
    } finally {
      setCargando(false)
    }
  }

  return (
    <div className="auth-root">
      {/* Panel izquierdo decorativo - igual que en Login */}
      <div 
        className="auth-panel-left"
        style={{
          backgroundImage: `url(${fondoFogata})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {/* Sin flor de lis grande */}
        {/* <div className="panel-flor-de-lis">⚜️</div>  ← Eliminado */}

        <div className="panel-logo">
          <img 
            src={logoGrupo} 
            alt="Logo del Grupo Scout" 
            className="panel-logo-icon-img"
            style={{ 
              width: '90px',           // Mismo tamaño que pusiste en Login
              height: '90px',
              objectFit: 'contain'
            }}
          />
          <span className="panel-logo-text">NSDP<br />Finanzas</span>
        </div>

        <div className="panel-quote">
          <p className="panel-quote-texto">
            "Un scout es leal<br />a quienes dependen de él."
          </p>
          <p className="panel-quote-autor">Ley Scout</p>
        </div>
      </div>

      {/* Panel derecho: formulario (sin cambios) */}
      <div className="auth-panel-right">
        <div className="auth-form-wrapper">
          <h1 className="auth-titulo">Crear cuenta</h1>
          <p className="auth-subtitulo">
            Tu cuenta comenzará con acceso de visualización.<br />
            Un administrador puede darte acceso completo.
          </p>

          {error && (
            <div className="auth-error">
              <span>⚠</span> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="auth-field">
              <label className="auth-label" htmlFor="email">Correo electrónico</label>
              <input
                id="email"
                className="auth-input"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="dirigente@scouts.cl"
                autoComplete="email"
              />
            </div>

            <div className="auth-field">
              <label className="auth-label" htmlFor="password">Contraseña</label>
              <input
                id="password"
                className="auth-input"
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Mínimo 6 caracteres"
                autoComplete="new-password"
              />
            </div>

            <div className="auth-field">
              <label className="auth-label" htmlFor="confirmar">Confirmar contraseña</label>
              <input
                id="confirmar"
                className="auth-input"
                type="password"
                name="confirmar"
                value={form.confirmar}
                onChange={handleChange}
                placeholder="Repite tu contraseña"
                autoComplete="new-password"
              />
            </div>

            <button className="auth-btn" type="submit" disabled={cargando}>
              {cargando && <span className="auth-btn-spinner" />}
              {cargando ? "Creando cuenta..." : "Registrarse"}
            </button>
          </form>

          <p className="auth-link-text">
            ¿Ya tienes cuenta?
            <Link className="auth-link" to="/login">Inicia sesión</Link>
          </p>
        </div>
      </div>
    </div>
  )
}